const state = {
    itens: [],
    item: {
        status: '',
        finish_contract: false,
        auto_finish: false
    }
};

export default state;